import { setFallbackImage } from "../../../../../../../components/image/imageWithFallback.shared";

export const ProductItemImage = ({ imageUrl }: { imageUrl: string | null }) => {
  // TODO: add blurry product/supplier image fallback when models removed, see DiscoveryListProductCard.tsx for reference

  const imageOrFallbackImageUrl = setFallbackImage({
    img: imageUrl,
    fallback: "product-hero",
  });

  return (
    <div
      className={
        "aspect-square h-14 w-14 shrink-0 rounded-lg border border-zinc-300"
      }
    >
      <div
        className={
          "h-full w-full rounded-lg bg-cover bg-center bg-no-repeat object-cover"
        }
        style={{
          backgroundImage: `url(${imageOrFallbackImageUrl})`,
        }}
      />
    </div>
  );
};
